module.exports = __webpack_public_path__ + "static/media/s_v8_t5.d27118e3.mp3";